import { IComponentNode, IPage } from 'app/app/editor/index.functions';
import { generateUid, processPageContainersUid } from 'app/app/editor/page/index';

export default function insertComponentIntoPage(
    scrPage: IPage,
    type: string,
    dropPath: Array<string>,
    componentAfterId: string,
): { newPage: IPage; uid: string } {
    const isContainer = type == 'container';

    const newPage = structuredClone(scrPage);

    // TODO: provide default component settings
    const component = { component: type, settings: {} };
    const uid = generateUid(newPage.components, type);
    if (!isContainer) {
        newPage.components[uid] = component;
    }

    let k = newPage.layout;
    for (const key of dropPath) {
        for (let j = 0; j < (k.elements?.length ?? 0); j++) {
            let element = k.elements?.[j];
            if (element && element.type == 'container' && 'mi-app-' + element.params.uid == key) {
                k = element;
                break;
            }
        }
    }
    if (!k.elements) {
        k.elements = [];
    }
    // TODO: provide default element params
    const element: IComponentNode = { type: isContainer ? 'container' : 'component', params: { uid: uid } };

    const elUid = document.getElementById(componentAfterId)?.dataset['uid'] ?? '';
    let index = k.elements.findIndex((element: any) => element?.params?.uid && element.params.uid == elUid);

    if (index > -1) {
        k.elements.splice(index + 1, 0, element);
    } else {
        k.elements.unshift(element);
    }
    processPageContainersUid(newPage.layout, 'container');

    return { newPage, uid };
}
